import { KeyboardArrowDown } from "@mui/icons-material";

import HNSColors from "../../HNSColors";

const CustomArrowIcon = (props) => {
  return (
    <KeyboardArrowDown
      {...props}
      sx={{
        fontSize: 24,
        color: props.disabled
          ? `${HNSColors.neutrals[500]} !important`
          : `${HNSColors.primary[500]} !important`,
      }}
    />
  );
};

export default CustomArrowIcon;
